$(document).ready(function() {
      function openPopup() {
        $("#popupOverlay").fadeIn(300).css("display", "flex");
        $("body").addClass("overflow-hidden");
    }
    function closePopup() {
        $("#popupOverlay").fadeOut(300);
         $("body").removeClass("overflow-hidden");
    }

   $(document).on("click", ".header__icon-newsletterform", function() {
  openPopup();
});
    $(document).on("click", ".close-popup-form", function() {
  closePopup();
});
   $("#popupOverlay").on("click", function(event) {
        if (event.target === this) {
            closePopup();
        }
    });
// Description JS
// Initially show only first two rows, hide the rest with .hidden
$(".specs-table-new table tr").each(function(index) {
  if (index >= 2) {
    $(this).addClass("hidden").hide();
  }
});

$(document).on('click', '.view-more-new', function() {
  const $this = $(this);

  if ($this.hasClass("active")) {
    // View Less: Slide up everything after the first two
    $(".specs-table-new table tr").each(function(index) {
      if (index >= 2) {
        $(this).addClass("hidden").slideUp();
      }
    });

    $this.removeClass("active").text("View More");

    // Smooth scroll back to the table top
    $('html, body').animate({
      scrollTop: $(".specs-table-new").offset().top-80
    }, 500);
    
  } else {
    // View More: Show all rows smoothly
    $(".specs-table-new table tr.hidden").removeClass("hidden").slideDown();
    $this.addClass("active").text("View Less");
  }
});


      $(".specs-table table tr.hidden").hide();
    $(document).on('click', '.view-more', function() {
    $(".specs-table table tr").removeClass("hidden");
       $(".specs-table table tr").removeAttr("style");
    $(this).addClass("active");
  });
  // FAQ-Desc
  $('.des-faq-answer').hide().first().show();
  $('.des-faq-question .des-icon').text('+');
  $('.des-faq-question').first().find('.des-icon').text('-');

  $('.des-faq-question').click(function () {
    const $clickedAnswer = $(this).next('.des-faq-answer');
    const isOpen = $clickedAnswer.is(':visible');

    // Close all answers and reset icons
    $('.des-faq-answer').slideUp();
    $('.des-faq-question .des-icon').text('+');

    if (!isOpen) {
      // Open clicked and set icon to -
      $clickedAnswer.slideDown();
      $(this).find('.des-icon').text('-');
    }
  });

   $('.scrollReviews').on('click', function(e) {
      e.preventDefault();
      const target = $('#judgeme_product_reviews');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 80
        }, 800);
      }
    });
  // Accordion Head Click
$(document).on("click", ".accordion_head", function (e) {
    e.preventDefault();
    var dataAttr = $(this).attr("data-get");
    if (dataAttr != null) {
        $('.accordion_body[data-get="' + dataAttr + '"]').addClass("active");
        $("body").addClass("open_drw_new");
    }
});
  // Close Accordion
$(document).on("click", ".close_tab", function () {
    $(".accordion_body").removeClass("active");
    $("body").removeClass("open_drw_new");
});

// Click Outside Accordion to Close
$(document).on("click", ".accordion_body", function (e) {
    if (!$(e.target).closest(".accordion_body_inner").length) {
        $(this).removeClass("active");
        $("body").removeClass("open_drw_new");
    }
});
 // Accordion Head Click

});


$(document).ready(function () {
  setTimeout(function () {
    var $slider = $('.custom__pdpslider');

    $slider.slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      nextArrow: '<button class="custom__next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="m19 12l12 12l-12 12"/></svg></button>',
      prevArrow: '<button class="custom__prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M31 36L19 24l12-12"/></svg></button>',
    });

    function updateArrows(currentSlide) {
      if (currentSlide === 0) {
        $('.custom__prev').hide();  // Hide left arrow
        $('.custom__next').show();  // Show right arrow
      } else {
        $('.custom__prev').show();  // Show both
        $('.custom__next').show();
      }
    }

    // Handle arrow logic after slider init and on every slide change
    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
      updateArrows(currentSlide || 0);
    });

    // Ensure arrows are correct on first hover
    $('.card__media').on('mouseenter', function () {
      let current = $slider.slick('slickCurrentSlide');
      updateArrows(current);
    });
  }, 1500);
  // Menu Hover
  $('[id^="Details-HeaderMenu-"]').each(function() {
    var $details = $(this);
    var $summary = $details.find('summary').first();

    $details.hover(
      function() {
        $details.attr('open', '');                  // Add "open" on hover
        $summary.attr('aria-expanded', 'true');      // Set aria-expanded to true
      },
      function() {
        $details.removeAttr('open');                 // Remove "open" after hover out
        $summary.attr('aria-expanded', 'false');     // Set aria-expanded to false
      }
    );
  });
  // Menu Hover
});





document.addEventListener('DOMContentLoaded', function() {
  let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

  // Highlight buttons if already wishlisted
  document.querySelectorAll('.custom_wishlist').forEach(btn => {
    const handle = btn.dataset.productHandle;

    if (wishlist.includes(handle)) {
      btn.classList.add('active');
    }

    btn.addEventListener('click', () => {
      const index = wishlist.indexOf(handle);

      if (index === -1) {
        wishlist.push(handle); // Add to wishlist
        btn.classList.add('active');
      } else {
        wishlist.splice(index, 1); // Remove from wishlist
        btn.classList.remove('active');
      }

      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      console.log("Current Wishlist:", wishlist); // for debugging
    });
  });
});



$('.youtube_slider .multicolumn-list').slick({
  dots:false,
  infinite:true,
  speed: 300,
  slidesToShow: 3,
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0668/5333/9348/files/left-arrow_1.png?v=1747497674'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0668/5333/9348/files/right-arrow.png?v=1747497674'>",
  slidesToScroll: 3,
  responsive: [
     {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots:true
      }
    },
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
         arrows:true,
        dots:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots:true,
        autoplay: true,
        autoplaySpeed:3000,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.zita-commit .multicolumn-list').slick({
  dots:false,
  infinite:true,
  speed: 300,
  slidesToShow: 4,
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0668/5333/9348/files/left-arrow_1.png?v=1747497674'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0668/5333/9348/files/right-arrow.png?v=1747497674'>",
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots:true
      }
    },
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
         arrows:true,
        dots:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots:true,
        centerMode:true,
         centerPadding: '80px',
          arrows:true,
        autoplay: true,
        autoplaySpeed:3000,
      }
    },
    {
      breakpoint: 325,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots:true,
          arrows:true,
        autoplay: true,
        autoplaySpeed:3000,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});







$(document).on("click", "#shopify-chat", function () {
  $(this).toggleClass("main-active");
});

$(document).on("click", ".help-toggle", function () {
  const $toggle = $(this);
  const $menu = $(".help-menu");
  const $chat = $("#shopify-chat");

  // Toggle visibility
  $("#shopify-chat").toggle();
  $menu.toggleClass("active");

  if ($menu.hasClass("active")) {
    $toggle.addClass("active");
    $("body").addClass("custom__active");
    $chat.addClass("custom__active");

    // Replace image with "X"
    $toggle.html('<span class="close-x">✕</span>');
  } else {
    $toggle.removeClass("active");
    $("body").removeClass("custom__active");
    $chat.removeClass("custom__active");

    // Bring back the help image
    $toggle.html('<img class="help-icon" src="https://cdn.shopify.com/s/files/1/0668/5333/9348/files/WhatsApp_Image_2025-08-12_at_9.15.12_PM-removebg-preview.png?v=1755014208" width="40" height="40">');
  }
});
document.querySelectorAll('.help-toggle').forEach(el => {
  el.addEventListener('click', () => {
    const chatWidget = document.querySelector('inbox-online-store-chat');
    const shadowRoot = chatWidget?.shadowRoot;
    if (!shadowRoot) return console.log('Shadow root not found');
    
    const closeBtn = shadowRoot.querySelector('button[class*="chat-app--close-button"]');
    if (closeBtn) closeBtn.click();
    else console.log('Close button not found');
  });
});
document.querySelectorAll('.help-toggle').forEach(el => {
  el.addEventListener('click', () => {
    const chatWidget = document.querySelector('inbox-online-store-chat');
    const shadowRoot = chatWidget?.shadowRoot;
    if (!shadowRoot) return console.log('Shadow root not found');
    
    const closeBtn = shadowRoot.querySelector('button[aria-label="Close chat window"][name="closeChat"]');
    if (closeBtn) closeBtn.click();
    else console.log('Close button not found');
  });
});
function updateShadowChat() {
  const chatWidget = document.querySelector('inbox-online-store-chat');
  const shadowRoot = chatWidget?.shadowRoot;
  if (!shadowRoot) return;

  const container = shadowRoot.querySelector('.chat-title');
  if (!container) return;

  if (document.body.classList.contains("customNew-index")) {
    container.classList.add("my-custom-class");
    container.style.display = "flex";
  } else {
    container.classList.remove("my-custom-class");
    container.style.display = "none";
  }
}

document.addEventListener("DOMContentLoaded", () => {
  updateShadowChat();
  const observer = new MutationObserver(updateShadowChat);
  observer.observe(document.body, { attributes: true, childList: true, subtree: true });
});

function injectChatButtonStyles() {
  const chatWidget = document.querySelector('inbox-online-store-chat');
  const shadowRoot = chatWidget?.shadowRoot;
  if (!shadowRoot) return;

  const style = document.createElement('style');
  style.textContent = `
    /* When the text is visible */
    button.chat-toggle--text-button:not(:has(.chat-title[style*="display: none"])) {
      width: 250px !important;
      border-radius: 20px !important;
      max-width: unset !important;
      justify-content: flex-start !important;
    }

    /* When the text is hidden */
    button.chat-toggle--text-button:has(.chat-title[style*="display: none"]) {
      width: 60px !important;
      border-radius: 50% !important;
      max-width: unset !important;
      padding: 0 3px 0 3px !important;
    }
    
    button span.chat-title{
       margin: unset !important;
       font-size:18px !important;
       font-family: Quicksand, sans-serif !important;
    }
    button[class*="chat-toggle--text-button"]:hover {
        transform: scale(1.1);
   }
        .interstitial-view__welcome .store-info {
    padding: 50px 16px 76px !important;
}
  `;
  shadowRoot.appendChild(style);
}
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(injectChatButtonStyles);
  observer.observe(document.body, { childList: true, subtree: true });
  injectChatButtonStyles(); 
});
// End Live Chat Conditions
document.addEventListener("DOMContentLoaded", () => {
  let soundPlayed = false;

  function playPopupSound() {
    if (soundPlayed) return;
    soundPlayed = true;

    // Show the floating help text with animation
    const helpText = document.querySelector(".icon-help-text-float");
    if (helpText) {
      helpText.style.display = "block";
      setTimeout(() => helpText.classList.add("show"), 50); // delay for transition
    }

    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;

    const ctx = new AudioContext();
    if (ctx.state === "suspended") {
      ctx.resume().catch(() => {});
    }

    // Load and play popup sound
    fetch("https://cdn.shopify.com/s/files/1/0668/5333/9348/files/A_hollow_wooden_pop_for_rustic_and_traditional-style_applications..wav?v=1755194229") // Replace with your sound file URL
      .then(response => response.arrayBuffer())
      .then(data => ctx.decodeAudioData(data))
      .then(buffer => {
        const source = ctx.createBufferSource();
        source.buffer = buffer;
        source.connect(ctx.destination);
        source.start(0);
      })
      .catch(err => console.error("Error loading sound:", err));
  }

  // Play after 3 seconds
  setTimeout(playPopupSound, 3000);
});